import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { env } from '@fantaz/shared/app-config';
import { setupMockService } from '@fantaz/shared/testing';

import { AppModule } from './app/app.module';

const enableMocking = env.name === 'mock';

const runApp = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
};

if (enableMocking) {
  setupMockService().then(() => runApp());
} else {
  runApp();
}
